import { useQuery } from '@tanstack/react-query'
import knowledgeApi from '@/lib/knowledge-api'
import type { InteractionDetail } from '../types'

export function useInteractionDetail(sessionId: string | undefined) {
  return useQuery({
    queryKey: ['interaction', sessionId],
    queryFn: async () => {
      if (!sessionId) throw new Error('Session ID is required')

      const response = await knowledgeApi.get<InteractionDetail>(
        `/knowledge/interactions/${sessionId}/`
      )

      return response.data
    },
    enabled: !!sessionId,
  })
}
